import { createReducer, on } from '@ngrx/store';
import { AuditLabel, CommsLabel, CommsPanelChildType, NotesLabel, SegmentLabelType, SelectedPatientSegmentPanel, SheetLabel, TasksLabel, VisitLabel } from 'src/app/types/patient.types';
import { clearStateRequested } from '../auth/auth.actions';
import * as patientActions from './patient.actions';

export interface State {
	patientSelected: boolean;
	segmentLabel: SegmentLabelType;
	selectedPatientSegmentPanel: SelectedPatientSegmentPanel;
	selectedCommsPanelChildType: CommsPanelChildType;
}

export const initialState: State = {
	patientSelected: false,
	segmentLabel: VisitLabel,
	selectedPatientSegmentPanel: SelectedPatientSegmentPanel.None,
	selectedCommsPanelChildType: CommsPanelChildType.None
}

export const patientReducer = createReducer(
	initialState,
	on(patientActions.patientSelected, (state, { segmentLabel }) => ({
		...state,
		patientSelected: true,
		segmentLabel: segmentLabel,
		selectedPatientSegmentPanel: getSelectedPatientSegmentPanel(segmentLabel)
	})),
	on(patientActions.patientDeselected, () => initialState),
	on(patientActions.segmentChanged, (state, { label }) => ({
		...state,
		segmentLabel: label,
		selectedPatientSegmentPanel: getSelectedPatientSegmentPanel(label)
	})),
	on(patientActions.commsPanelChildSelected, (state, { childType }) => ({
		...state,
		selectedCommsPanelChildType: childType
	})),
	on(clearStateRequested, () => initialState)
);

const getSelectedPatientSegmentPanel = (segmentLabel: SegmentLabelType): SelectedPatientSegmentPanel => {
	switch (segmentLabel) {
		case VisitLabel:
			return SelectedPatientSegmentPanel.Visit;
		case NotesLabel:
			return SelectedPatientSegmentPanel.Notes;
		case SheetLabel:
			return SelectedPatientSegmentPanel.Sheet;
		case TasksLabel:
			return SelectedPatientSegmentPanel.Tasks;
		case CommsLabel:
			return SelectedPatientSegmentPanel.Comms;
		case AuditLabel:
			return SelectedPatientSegmentPanel.Audit;
		default:
			return SelectedPatientSegmentPanel.None;
	}
};